/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Review_FlowInputs */

const en_svchip_review_flow = /** @type {(inputs: Svchip_Review_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review flow`)
};

const ar_svchip_review_flow = /** @type {(inputs: Svchip_Review_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تدفق المراجعة`)
};

const bn_svchip_review_flow = /** @type {(inputs: Svchip_Review_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রিভিউ ফ্লো`)
};

const de_svchip_review_flow = /** @type {(inputs: Svchip_Review_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überprüfungsablauf`)
};

const es_svchip_review_flow = /** @type {(inputs: Svchip_Review_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flujo de revisión`)
};

const fr_svchip_review_flow = /** @type {(inputs: Svchip_Review_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flux de révision`)
};

const pt_svchip_review_flow = /** @type {(inputs: Svchip_Review_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fluxo de revisão`)
};

const zh_svchip_review_flow = /** @type {(inputs: Svchip_Review_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`审核流程`)
};

const tr_svchip_review_flow = /** @type {(inputs: Svchip_Review_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İnceleme akışı`)
};

const ru_svchip_review_flow = /** @type {(inputs: Svchip_Review_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Порядок проверки`)
};

const pl_svchip_review_flow = /** @type {(inputs: Svchip_Review_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przejrzyj przepływ`)
};

/**
* | output |
* | --- |
* | "Review flow" |
*
* @param {Svchip_Review_FlowInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_review_flow = /** @type {((inputs?: Svchip_Review_FlowInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Review_FlowInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_review_flow(inputs)
	if (locale === "bn") return bn_svchip_review_flow(inputs)
	if (locale === "de") return de_svchip_review_flow(inputs)
	if (locale === "es") return es_svchip_review_flow(inputs)
	if (locale === "fr") return fr_svchip_review_flow(inputs)
	if (locale === "pt") return pt_svchip_review_flow(inputs)
	if (locale === "zh") return zh_svchip_review_flow(inputs)
	if (locale === "tr") return tr_svchip_review_flow(inputs)
	if (locale === "ru") return ru_svchip_review_flow(inputs)
	if (locale === "pl") return pl_svchip_review_flow(inputs)
	return en_svchip_review_flow(inputs)
});